import constants from 'constants/index'
import { isEmpty } from 'lodash'

const { CONTROLLER_TYPE, OPERATOR_TYPE, CO_CONTROLLER_TYPE, SUBOPERATOR_TYPE } =
  constants.dataTreatmentAgents

const agentTypeOfCompanySelf = (agents) => {
  const types = agents?.map((agent) => {
    if (agent.companySelf) {
      return agent.agentType
    }
    return null
  })

  if (isEmpty(types)) return ''
  if (types.includes(CONTROLLER_TYPE)) return CONTROLLER_TYPE
  if (types.includes(OPERATOR_TYPE)) return OPERATOR_TYPE
  if (types.includes(CO_CONTROLLER_TYPE)) return CO_CONTROLLER_TYPE
  if (types.includes(SUBOPERATOR_TYPE)) return SUBOPERATOR_TYPE

  return ''
}

export default agentTypeOfCompanySelf
